import { render, staticRenderFns } from "./MenuExterno.vue?vue&type=template&id=bf0b22e6&scoped=true"
import script from "./MenuExterno.vue?vue&type=script&lang=js"
export * from "./MenuExterno.vue?vue&type=script&lang=js"
import style0 from "./MenuExterno.vue?vue&type=style&index=0&id=bf0b22e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0b22e6",
  null
  
)

export default component.exports